import React from 'react';

// The user backend stores these on the case when it renders the signing
// documents (poa_warnings). They describe what in the Portuguese column of the
// power of attorney Finanças would not accept. Lawyer-facing only: the
// customer never sees them.
const LEGACY_PREFIX = 'signed before the Portuguese fix: ';

const LABELS: Array<[string, string]> = [
  ['non-Latin text: ', 'Text not in Latin letters: '],
  ['nationality not recognised: ', 'Nationality could not be translated: '],
  ['nationality not translated: ', 'Nationality not in Portuguese: '],
  ['issuing agency instead of the state: ', 'Issued by an agency instead of the country: '],
  ['middle name missing: ', 'Middle name missing: '],
];

export function describePoaWarning(warning: string): string {
  const text = warning.startsWith(LEGACY_PREFIX) ? warning.slice(LEGACY_PREFIX.length) : warning;
  if (text.startsWith('issuing state unknown')) {
    return 'Issuing country unknown, so the POA does not say who issued the document';
  }
  for (const [prefix, label] of LABELS) {
    if (text.startsWith(prefix)) {
      return label + text.slice(prefix.length);
    }
  }
  return text;
}

const FINISHED_STATUSES = new Set(['Complete', 'Closed']);

interface Props {
  warnings?: string[] | null;
  lawyerStatus?: string;
}

const PoaWarningsBanner: React.FC<Props> = ({ warnings, lawyerStatus }) => {
  if (!warnings || warnings.length === 0 || FINISHED_STATUSES.has(lawyerStatus ?? '')) {
    return null;
  }
  const signedWithOldWording = warnings.some((w) => w.startsWith(LEGACY_PREFIX));

  return (
    <div className="final-doc-warning poa-warnings-banner" role="alert" data-testid="poa-warnings">
      <strong>POA needs a check before submission</strong>
      <p className="poa-warnings-intro">
        {signedWithOldWording
          ? 'This case was signed with the old POA wording, which Finanças may return. Correcting it needs a new signature from the customer.'
          : 'The Portuguese part of the signed POA is not fully Portuguese. Finanças may return it.'}
      </p>
      <ul className="poa-warnings-list">
        {warnings.map((warning) => (
          <li key={warning}>{describePoaWarning(warning)}</li>
        ))}
      </ul>
    </div>
  );
};

export default PoaWarningsBanner;
